import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { WalletDesignAnalysis } from './wallet-design';

@Injectable({
  providedIn: 'root'
})
export class WalletDesignService {

  constructor(private http: HttpClient) {
  }

  analyze(pdf: File): Observable<WalletDesignAnalysis> {
    const formData = new FormData();
    formData.append('pdf', pdf);
    return this.http.post<WalletDesignAnalysis>(`${environment.base_url}wallet_designs/analyze`, formData);
  }
}
